'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONVERSATION_STARTED = exports.CONVERSATION_STARTED = 'conversationStarted';

var CONVERSATION_CLOSED = exports.CONVERSATION_CLOSED = 'conversationClosed';

var UNREAD_CONVERSATION_COUNT_CHANGED = exports.UNREAD_CONVERSATION_COUNT_CHANGED = 'unreadConversationCountChanged';


//////////////////
// WEBPACK FOOTER
// ./js/external-api-events/constants/externalApiEventTypes.js
// module id = 191
// module chunks = 2 3